<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Logs de integração
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  consultar
        |  logs de jobs de integração e
        strong  tentar novamente
        |  em
        strong  Configurações → Logs de integração
        | .

      .toast.toast-primary
        | Exige
        strong  Sistema → Logs de integração → Listar
        | . O botão
        strong  Tentar novamente
        |  exige
        strong  Sistema → Logs de integração → Re tentar
        | .

      h5.h5 1. Abrir Logs de integração
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Clique em
          strong  Logs de integração
          | .

      h5.h5 2. Filtros e listagem
      p
        | Filtre por
        strong  Tarefa
        |  (Documento: Implantar no Tributário, Gerar PAF no SEI; OS-m: Enviar PDF/dados/status
        |  para SEI ou PGD, Concluir vistoria no Peits) e por
        strong  Status
        |  (Aguardando, Executando, Pronto, Erro). Use “Todas tarefas” / “Todos status” para limpar.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de logs de integração")
      ol
        li Cada card mostra a tarefa, a data de inserção e o status (destaque verde se Pronto, vermelho se Erro).
        li O corpo exibe o
          strong  Output
          |  da execução (pode conter links).
        li Use a paginação se houver várias páginas.

      h5.h5 3. Tentar novamente
      ol
        li Quando o log permitir retry, o rodapé do card mostra
          strong  Tentar novamente
          | .
        li Confirme a mensagem
          em Ao confirmar vai tentar integrar novamente.
          | .
        li Após o sucesso, a lista é recarregada.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/45-config-logs-integracao-lista.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
